export enum ProgressStatus {
  Success = 'success',
  Exception = 'exception',
  Active = 'active',
  Normal = 'normal'
}
